import { BaseComponent } from "./base-component";
import { Injector, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material";
import { AEntity } from "../models/a-entity";
import { CrudService } from "../services/crud.service";
import { DialogWindowComponent } from "./dialog-window/dialog-window.component";

export abstract class ListComponent<T extends AEntity, U extends CrudService<T>> extends BaseComponent implements OnInit {
    rows: T[] = [];
    limit: number = 20;

    protected _dataProperty: string;

    protected _service: U;
    protected _dialog: MatDialog;

    protected _baseUrl: string;
    protected get baseUrl(): string { return this._baseUrl; }

    /**
     * Create a global class to manage list component actions
     * @param injector - injector root service used in app.module
     */
    constructor(service: { new(Injector): U; }, injector: Injector, baseUrl: string, dataProperty: string = undefined) {
        super(injector);

        if (baseUrl) {
            this._baseUrl = baseUrl;
            if (!this._baseUrl.startsWith('/')) this._baseUrl = '/' + this._baseUrl;
            if (!this._baseUrl.endsWith('/')) this._baseUrl += '/';
        }

        this._dialog = injector.get(MatDialog);
        this._service = new service(injector);
        this._dataProperty = dataProperty;
    }

    ngOnInit(): void {
        this.refresh();
    }

    protected refresh() {
        this._service.readAll().subscribe(res => {
            if (this._dataProperty) this._authService.data[this._dataProperty] = res;
            this.rows = res;
        });
    }

    changeActivePage(id: number) {
        this.navigate(this._baseUrl + id, undefined, true);
    }

    add() {
        this.changeActivePage(-1);
    }

    delete(model: AEntity, property: string = 'code') {
        this._dialog.open(DialogWindowComponent,
            { disableClose: true, autoFocus: true, data: { title: 'common.action.deletion', message: 'common.action.confirmDelete', messageParams: { "id": model[property] } } }
        ).afterClosed().subscribe(result => {
            if (result) this._service.deleteOne(model.id).subscribe(res => { this.refresh(); });
        });
    }

    canAdd(row: T) { return this._authService.hasRight(this.structurePath + '/create'); }
    canEdit(row: T) { return this._authService.hasRight(this.structurePath + '/read'); }
    canDelete(row: T) { return this._authService.hasRight(this.structurePath + '/delete'); }
}
